import React from 'react'
export default function AngleLeftArrowIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17"><path d="m7.527 8.475 2.36-2.36a.667.667 0 1 0-.947-.94L6.113 8a.667.667 0 0 0 0 .947l2.827 2.86a.667.667 0 0 0 .473.193.667.667 0 0 0 .474-.193.667.667 0 0 0 0-.94l-2.36-2.393Z"/></svg>)
}
